export const Banners = [
  'images/banners/banner1.png',
  'images/banners/banner2.png',
  'images/banners/banner3.png',
  'images/banners/banner4.png',
  'images/banners/banner5.png',
];
